import { RootState } from 'app/store/rootReducer';

export const getLoadingStatus = (state: RootState) =>
  state.simpleDocuments.isLoading;
